import React from "react";

export default function About({ details }) {
  return (
    <div className="bg-neutral-100">
      <div className="flex flex-col min-h-[200px] mt-8 bg-white px-4 py-8 rounded-lg">
        <span>Overview</span>
        <span className="text-gray-500 text-justify">
          {details.about}
        </span>
      </div>
    </div>
  );
}
